import { useMemo, useState, type ReactNode } from 'react';
import { PageTopbarAdornmentContext } from './page-topbar-adornment-context';

export function PageTopbarAdornmentProvider({ children }: { children: ReactNode }) {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  const value = useMemo(() => ({ container, setContainer }), [container]);

  return (
    <PageTopbarAdornmentContext.Provider value={value}>
      {children}
    </PageTopbarAdornmentContext.Provider>
  );
}
